export const TRANSACTION_TYPES = {
  blk: 'blk'
}

export const GATEWAYS = {
  girogate: 'Girogate'
}
